import { makeStyles } from "@material-ui/core";

export default makeStyles(
  () => ({
    grid: {
      marginBottom: 40,
    },
    lazyLoadWrapper: {
      height: "100%",
    },
  }),
  { name: "StarringYouCards" },
);
